import { default as latestEdits } from "components/Charts/LatestEdits/LatestEdits.reducer";
import autocomplete from "components/Form/components/Autocomplete/Autocomplete.reducer";
import referenceLabels from "components/Form/components/ReferenceLabel/ReferenceLabel.reducer";
import listing from "components/Listing/Listing.reducer";
import { default as plugins } from "components/PluginsPopover/Plugin.reducer";
import provisioningState from "components/ProvisioningStateDot/ProvisioningState.reducer";
import auth from "containers/Auth/Auth.reducer";
import identityRole from "containers/Auth/screens/IdentityManagement/IdentityRole.reducer";
import bundleManager from "containers/BundleManager/Bundles.reducer";
import bundleRepositories from "containers/BundleRepositories/BundleRepositories.reducer";
import bundles from "containers/Bundles/Bundles.reducer";
import executions from "containers/Executions/Executions.reducer";
import messages from "containers/Messages/Messages.reducer";
import projects from "containers/Projects/Projects.reducer";
import nonProjectRecords from "containers/Projects/components/ProjectTree/NonProjectRecords/NonProjectRecords.reducer";
import resources from "containers/Resources/Resources.reducer";
import wrappers from "containers/Resources/screens/ResourcesSingle/components/ResourceWrapper/WrapperList.reducer";
import dependencyVisualization from "containers/Resources/screens/ResourcesSingle/components/Visualization/DependencyVisualization/dependencyVisualization.reducer";
import stats from "containers/Stats/Stats.reducer";
import upload from "containers/Upload/Upload.reducer";
import workspaceConfig from "containers/WorkspaceConfig/WorkspaceConfig.reducer";
import workspaceSettings from "containers/WorkspaceSettings/WorkspaceSettings.reducer";
import workspaces from "containers/Workspaces/Workspaces.reducer";
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import dataStore from "utils/DataStore/DataStore.reducer";
import notificationManager from "utils/NotificationManager/NotificationManager.reducer";

//  Combining all existing reducers
const appReducer = combineReducers({
    //  Core
    auth,
    notificationManager,
    listing,
    //  App
    projects,
    bundles,
    nonProjectRecords,
    messages,
    upload,
    workspaces,
    workspaceConfig,
    workspaceSettings,
    stats,
    resources,
    executions,
    autocomplete,
    referenceLabels,
    plugins,
    wrappers,
    latestEdits,
    identityRole,
    bundleManager,
    bundleRepositories,
    dependencyVisualization,
    dataStore,
    provisioningState,
});

const rootReducer = (state, action) => {
    if (action.type === "SIGN_OUT_SUCCESSFUL") {
        // The persist key is configured as "state" in store/index.js, so redux-persist
        // writes to localStorage under "persist:state" — not the default "persist:root".
        storage.removeItem("persist:state");
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
